module.exports = __webpack_public_path__ + "media/images/infinite_pass_logo-6817e7f2b66484bc01fe0ba3462ab934.png";